export const assignLocation = (path: string): void => {
  window.location.assign(path)
}

export const reloadLocation = (): void => {
  window.location.reload()
}
